module.exports = __webpack_public_path__ + "static/media/front.3bbc38b8.jpg";